import { render, staticRenderFns } from "./BuiltValue.vue?vue&type=template&id=b3a694c8&"
import script from "./BuiltValue.vue?vue&type=script&lang=js&"
export * from "./BuiltValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports